import { InjectionToken } from '@angular/core';
import { BaseApiClientLabelsService } from '../base-api-client-labels.service';

export const API_CLIENT_LABELS_SERVICE = new InjectionToken<BaseApiClientLabelsService>(
  'BaseApiClientLabelsService'
);